<template>
  <div class="stepper-container">

    <!-- CABEÇALHO -->
    <div class="steps-header">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="step-wrapper"
      >
        <!-- STEP -->
        <div
          class="step"
          :class="{ active: currentStep === index, completed: index < currentStep }"
          @click="goTo(index)"
        >
          <div class="step-indicator">
            <font-awesome-icon
              v-if="step.icon"
              :icon="step.icon"
            />

            <span v-else>
              {{ index + 1 }}
            </span>
          </div>

          <span class="step-label">
            {{ step.label || ('Etapa ' + (index + 1)) }}
          </span>
        </div>

        <!-- SETA -->
        <div
          v-if="index < steps.length - 1"
          class="step-arrow"
          :class="{ active: index < currentStep }"
        >
          <font-awesome-icon
            :icon="faChevronRight"
          />
        </div>
      </div>
    </div>

    <!-- ÁREA DO CONTEÚDO -->
    <div class="steps-content">
      <slot :name="'step-'+currentStep" />
    </div>

    <!-- RODAPÉ -->
    <div
      v-if="showFooter"
      class="steps-footer"
    >
      <slot
        name="footer"
        :currentStep="currentStep"
        :isLast="currentStep === steps.length - 1"
        :goNext="next"
        :goPrev="prev"
      >
        <!-- FOOTER PADRÃO (SE NÃO TIVER SLOT) -->

        <b-button
          variant="secondary"
          :disabled="currentStep === 0"
          @click="prev"
        >
          Voltar
        </b-button>

        <b-button
          v-if="currentStep < steps.length - 1"
          variant="primary"
          class="ml-2"
          @click="next"
        >
          Próximo
        </b-button>

        <b-button
          v-else
          variant="success"
          class="ml-2"
          @click="$emit('finish')"
        >
          Finalizar
        </b-button>
      </slot>
    </div>

  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'Stepper',
  components: {
    FontAwesomeIcon,
  },

  props: {
    steps: {
      type: Array,
      required: true,
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      currentStep: 0,
      faChevronRight,
    }
  },

  methods: {
    next() {
      if (this.currentStep < this.steps.length - 1) {
        this.currentStep += 1
      }
    },

    prev() {
      if (this.currentStep > 0) {
        this.currentStep -= 1
      }
    },

    goTo(index) {
      this.currentStep = index
    },
  },
}
</script>

<style>
.stepper-container {
  width: 100%;
}

.steps-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.step-wrapper {
  display: flex;
  align-items: center;
}

.step {
  text-align: center;
  cursor: pointer;
}

.step-indicator {
  width: 32px;
  height: 32px;
  margin: 0 auto 5px;
  border-radius: 50%;
  border: 2px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  color: #777;
}

.step-label {
  font-size: 13px;
  color: #777;
}

/* STEP ativo */
.step.active .step-indicator {
  border-color: var(--primary);
  color: var(--primary);
}

/* STEP completo */
.step.completed .step-indicator {
  background: var(--primary);
  color: white;
  border-color: var(--primary);
}

/* SETA ENTRE OS STEPS */
.step-arrow {
  margin: 0 14px;
  color: #b3b3b3;
  font-size: 16px;
}

/* SETA ativa (quando o passo anterior está concluído) */
.step-arrow.active {
  color: var(--primary);
}
</style>
